export enum SeverityType {
    SUCCESS = "success",
    INFO = "info",
    WARN = "warn",
    ERROR = "error",
}
